import { DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI } from '../../entities';
import { NounSubtypeKey, TypeFilterValueKey } from '../../filters/universal-type';
import { get3PLogo } from '../../icons';
import { type ThirdPartyConfig } from '../../schemas/3p-config';

import { OneDriveIcon } from './icon';
import { OneDriveIconBorderless } from './icon-borderless';
import { OneDriveSearchResultIcon } from './search-result-icon';

export const oneDriveConfig: ThirdPartyConfig = {
	displayName: 'OneDrive',
	id: 'onedrive',
	resourceType: 'onedrive-connector',
	icon: get3PLogo(OneDriveIcon, 'OneDrive', 'medium'),
	iconBorderless: get3PLogo(OneDriveIconBorderless, 'OneDrive', 'small'),
	searchResultIcon: get3PLogo(OneDriveSearchResultIcon, 'OneDrive', 'large'),
	integrationAri: 'ari:cloud:platform::integration/microsoft',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Document,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
				subTypes3P: [NounSubtypeKey.Document, NounSubtypeKey.Pdf],
			},
		],
		[
			TypeFilterValueKey.Spreadsheet,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
				subTypes3P: [NounSubtypeKey.Spreadsheet],
			},
		],
		[
			TypeFilterValueKey.Presentation,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
				subTypes3P: [NounSubtypeKey.Presentation],
			},
		],
	]),
	filters: ['lastUpdated', 'onlyTitleMatch'],
	requiresOauth: true,
	isEnabled: () => true,
};
